module.exports = __webpack_public_path__ + "static/media/color3.e60a3b90.jpg";